import {
  SET_FETCH_STATUS,
  SET_FETCH_DEFAULTS,
  REQUEST_STATE,
  SET_FETCH_LOADING,
  LOAD_IO_STATE_BY_BOOK_ID,
  IMAGES_LOADING,
  AUTOFILL_FINISHED,
  CONVERT_FINISHED,
} from '../../action-types/entities/io';

import {
  getParams,
  getDomain } from '../../helpers/getParams';
import {
  orderBy,
  configExist } from '../../helpers';


export const setFetchDefaults = () => ({
  type: SET_FETCH_DEFAULTS,
});

export const autofillFinished = status => ({
  type: AUTOFILL_FINISHED,
  status,
});

export const convertFinished = status => ({
  type: CONVERT_FINISHED,
  status,
});

export const setFetchLoading = isLoading => ({
  type: SET_FETCH_LOADING,
  isLoading,
});

export const setFetchStatus = status => ({
  type: SET_FETCH_STATUS,
  status,
});

export const requestState = () => ({
  type: REQUEST_STATE,
});

export const imagesLoading = status => ({
  type: IMAGES_LOADING,
  status,
});

export function getPrintState(getState) {
  const state = getState;

  const {
    cover,
    bookSizes,
  } = state.bookProperties;

  const {
    label,
    type,
    coverSizes,
  } = cover;

  const {
    width,
    height,
  } = bookSizes;

  const { byId: pageList } = state.entities.pages;
  const { byId: placeholderList } = state.entities.placeholders;

  const orderedPages = orderBy(pageList, 'order');

  const getPages = orderedPages.map((element) => {
    const { backgroundColor } = element;
    const images = Object.values(element.placeholders).map((placeholder) => {
      const placeholderData = placeholderList[placeholder.placeholderId];

      const {
        top,
        left,
      } = placeholderData;

      const {
        scaleX: scale,
        rotate,
        moveX,
        moveY,
      } = placeholderData.transformations;

      return {
        pos: {
          x: top,
          y: left,
        },
        crop: {
          x: moveX,
          y: moveY,
        },
        width: placeholderData.width,
        height: placeholderData.height,
        scale,
        rotation: rotate,
        remoteID: placeholderData.imageObject ? placeholderData.imageObject.id : 0,
        thumbnail: placeholderData.imageObject ? placeholderData.imageObject.mediumThumbnail : '',
      };
    });

    return {
      images,
      backgroundColor,
    };
  });

  const printedState = {
    cover: {
      label,
      type,
    },
    pages: getPages,
    sizes: {
      cover: {
        width: coverSizes.width,
        height: coverSizes.height,
      },
      innerPages: {
        width,
        height,
      },
    },
  };

  return printedState;
}


export const saveState = (isUpdate = true) => (dispatch, getState) => {
  const { isChange } = getState().editorUI.imageChange;
  const { calendarId } = getState().bookProperties;
  const demoBookId = 0;
  if (isChange || calendarId === demoBookId) {
    return false;
  }
  dispatch(requestState());

  const referer = getDomain();

  const bookState = getState();
  const saveStateUrl = isUpdate ? configExist('updateStateUrl', referer) : configExist('saveStateUrl', referer);
  const apiSettings = {
    url: `${saveStateUrl}/${getParams('calendarId')}`,
    getState: JSON.stringify(bookState),
  };
  const {
    url, getState: apiState,
  } = apiSettings;

  const data = apiState;

  fetch(url, {
    method: 'POST',
    body: data,
    mode: 'no-cors',
    credentials: 'include',
    headers: new Headers({
      'Content-Type': 'application/json',
    }),
  })
    .then((response) => {
      if (response.status !== 200) {
        return dispatch(setFetchStatus('UnableToSave'));
      }
      return response.text();
    })
    .then(response => response)
    .then(() => dispatch(setFetchLoading('loaded')))
    .then(() => dispatch(setFetchLoading(false)))
    .catch((error) => {
      dispatch(setFetchStatus(error.message));
      dispatch(setFetchStatus('UnableToSave'));
      dispatch(setFetchLoading('loaded'));
      dispatch(setFetchLoading(false));
    });
};

export const loadIoStateByBookId = bookstate => ({
  type: LOAD_IO_STATE_BY_BOOK_ID,
  bookstate,
});



// WEBPACK FOOTER //
// ./src/redux/actions/entities/io.js